import { incotermApi } from "../../api";

const IncotermService = {
  fetchDropdown: async () => {
    const response = await incotermApi.fetchAll();
    return response.data;
  },
};

export default IncotermService;
